import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createEquipmentRquisition, getEquipmentRequisitions, returnRequisition } from "../../api/warehouse/requisition";
import { CreateRequisitionRequest } from "../../types/model/warehouse/requisition";

const queryKey = ["warehouse", "requisitions"];
const equipmentQueryKey = ["warehouse", "equipment"];

export const useWarehouseRequisitions = () => {
  const queryClient = useQueryClient();

  const result = useQuery({
    queryKey,
    queryFn: () => getEquipmentRequisitions(),
  });

  const invalidate = () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey }),
      queryClient.invalidateQueries({ queryKey: equipmentQueryKey }),
    ]);

  const createMutation = useMutation({
    mutationFn: (values: CreateRequisitionRequest) => createEquipmentRquisition(values),
    onSuccess: invalidate,
  });

  const returnMutation = useMutation({
    mutationFn: ({ requisitionId, equipmentIds }: { requisitionId: number; equipmentIds: number[] }) =>
      returnRequisition(requisitionId, { equipmentIds }),
    onSuccess: invalidate,
  });

  return {
    requisitionsData: result.data ?? [],
    isPending: result.isPending,
    isFetching: result.isFetching,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
    createRequisition: createMutation.mutateAsync,
    returnRequisition: returnMutation.mutateAsync,
    isUpdating: createMutation.isPending || returnMutation.isPending,
  };
};